import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/user.model';
import { BisualSettingService } from './bisual-setting.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  // Current user session
  private localstorageUserKey: string = 'bisual-user';
  private currentUserSubject: BehaviorSubject<User> = new BehaviorSubject(null as any);
  public currentUser: Observable<User> = this.currentUserSubject.asObservable();

  // Parent user session
  private _userParentLocalStorageKey: string = 'bisual-user-parent';
  private _currentParentUserSubject: BehaviorSubject<User> = new BehaviorSubject(null as any);
  public currentParentUser: Observable<User> = this._currentParentUserSubject.asObservable();

  private bisual_setting = inject(BisualSettingService);

  public getCurrentUser(): User {
    return this.currentUserSubject.value;
  }

  public setUser(user: User, keepAlive: boolean = true) {
    if (user != null && user != undefined) {
      if (keepAlive) {
        localStorage.setItem(this.localstorageUserKey, JSON.stringify(user));
      }
      this.currentUserSubject.next(user);
      this.bisual_setting.init(user); // inicia employee.init()
    }
  }

  public deleteUser() {
    localStorage.removeItem(this.localstorageUserKey);
    this.currentUserSubject.next(null as any);
  }

  /**
   * PARENT USER
   */
  public getCurrentParentUser() {
    return this._currentParentUserSubject.value;
  }

  public setParentUser(user: User) {
    if (user != null && user != undefined) {
      this._currentParentUserSubject.next(user);
      localStorage.setItem(this._userParentLocalStorageKey, JSON.stringify(user));
    }
  }

  public deleteParentUser() {
    this._currentParentUserSubject.next(null as any);
    localStorage.removeItem(this._userParentLocalStorageKey);
  }
}
